import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Main = ({
  size,
  type,
  theme,
  className,
  dataTestId = "main-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <g clipPath="url(#a)">
      <path
        fillRule="evenodd"
        d="M9.091.913a2 2 0 0 0-2.18 0L1.578 4.38a2 2 0 0 0-.91 1.677v7.276a2 2 0 0 0 2 2h10.667a2 2 0 0 0 2-2V6.057a2 2 0 0 0-.91-1.677L9.09.913ZM7.638 2.031a.667.667 0 0 1 .727 0l5.333 3.467c.19.123.303.333.303.559v7.276a.667.667 0 0 1-.666.667h-2.667V8.974c0-1.392-1.323-2.308-2.667-2.308-1.343 0-2.666.916-2.666 2.308V14h.788-3.455a.667.667 0 0 1-.667-.667V6.057c0-.226.114-.436.304-.56l5.333-3.466ZM6.668 14h3.454-.787V8.974C9.335 8.554 8.867 8 8 8c-.865 0-1.333.553-1.333.974V14Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </SVGIcon>
);
